import { BaseService } from "../BaseService";
import { GetDealerDataPayload, GetDealerDataResponse, GetDealerDataReturn } from "./types";
import { Environments } from "@/migrated-widgets/table-map/constants/Environments";

class ActiveDealerListServiceClass extends BaseService {
    constructor() {
        super(`${Environments.ACTIVE_DEALER_LIST_API_URL}`);
    }

    async getDealerData({ token, ...params }: GetDealerDataPayload): Promise<GetDealerDataReturn> {
        const { data } = await this.axios.get<GetDealerDataResponse>("", {
            params,
            headers: {
                Authorization: "Bearer " + token,
            },
        });
        const dealers = data.items ?? [];

        const dealerMarkers = dealers.map((item, index) => {
            return {
                raw: item,
                position: {
                    lat: Number(item.dealerLatitude),
                    lng: Number(item.dealerLongitude),
                },
                label: String(
                    `${item.dealerAddress.address ?? ""}, ${item.dealerAddress.city ?? ""}, ${item.dealerAddress.state ?? ""} ${item.dealerAddress.zip ?? ""}`,
                ),
                id: Number(item.dealerId),
            };
        });

        return { ...data, dealerMarkers };
    }
}

const ActiveDealerListService = new ActiveDealerListServiceClass();
export { ActiveDealerListService };
